import { setNotice } from './index';
import { unsetAuth } from '../auth';
import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';

type ApiErrorPayload = {
  status?: number | string;
  error?: string;
  data?: { statusCode?: number; message?: string | string[] };
};

/** Один и тот же текст не показываем чаще, чем раз в 5 секунд. */
const DEDUP_WINDOW_MS = 5_000;

let lastMessage = '';
let lastMessageAt = 0;

export const noticeMiddleware: Middleware = (store) => (next) => (action) => {
  // isRejectedWithValue пропускает только реальные ошибки запроса (rejectWithValue
  // из baseQuery) и отсекает служебные reject'ы RTK Query — прежде всего
  // ConditionError "Aborted due to condition callback returning false".
  // Он возникает штатно: polling дёргает запрос, который ещё в полёте,
  // и RTK его отменяет. Пользователю это показывать не нужно.
  if (!isRejectedWithValue(action)) return next(action);

  const isRefresh = (action.meta?.arg as { endpoint?: string } | undefined)?.endpoint === 'refresh';
  const payload = (action.payload || {}) as ApiErrorPayload;
  const isUnauthorized = payload.status === 401 || payload.data?.statusCode === 401;

  // Протухший токен раньше не обрабатывался никак: запросы молча падали
  // с 401, экран оставался в вечной загрузке, и понять причину было нельзя.
  // Возвращаем на экран логина.
  if (isUnauthorized) {
    if (store.getState()?.auth?.token) {
      store.dispatch(unsetAuth());
      store.dispatch(setNotice({ type: 'error', message: 'Session expired, sign in again' }));
    }

    return next(action);
  }

  if (isRefresh) return next(action);

  const raw = payload.data?.message || payload.error;
  const message = (Array.isArray(raw) ? raw.join(', ') : raw) || 'Request failed';

  // При секундном поллинге лежащий бэкенд иначе генерирует уведомление
  // каждую секунду.
  const now = Date.now();
  if (message === lastMessage && now - lastMessageAt < DEDUP_WINDOW_MS) {
    return next(action);
  }

  lastMessage = message;
  lastMessageAt = now;

  store.dispatch(setNotice({ type: 'error', message }));

  return next(action);
};
